module.exports = __webpack_public_path__ + "img/ewm2.df88a05d.png";